import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1.08153,
		y: .687978,
		width: 28.3164,
		height: 28.3164,
		rx: 14.1582,
		fill: "#F8F8F8",
		stroke: "#C8C8C8",
		strokeWidth: 1.20408
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.4192 14.8464L20.0158 11.2582C20.1733 11.1007 20.2617 10.887 20.2617 10.6643C20.2617 10.4416 20.1733 10.2279 20.0158 10.0704C19.8583 9.91295 19.6446 9.82446 19.4219 9.82446C19.1992 9.82446 18.9855 9.91295 18.828 10.0704L15.2398 13.667L11.6516 10.0704C11.4941 9.91295 11.2805 9.82446 11.0578 9.82446C10.835 9.82446 10.6214 9.91295 10.4639 10.0704C10.3064 10.2279 10.2179 10.4416 10.2179 10.6643C10.2179 10.887 10.3064 11.1007 10.4639 11.2582L14.0605 14.8464L10.4639 18.4346C10.3855 18.5123 10.3233 18.6049 10.2808 18.7068C10.2384 18.8087 10.2165 18.918 10.2165 19.0284C10.2165 19.1389 10.2384 19.2482 10.2808 19.3501C10.3233 19.452 10.3855 19.5445 10.4639 19.6223C10.5417 19.7007 10.6342 19.7629 10.7361 19.8054C10.838 19.8478 10.9473 19.8697 11.0578 19.8697C11.1682 19.8697 11.2775 19.8478 11.3794 19.8054C11.4813 19.7629 11.5739 19.7007 11.6516 19.6223L15.2398 16.0257L18.828 19.6223C18.9058 19.7007 18.9983 19.7629 19.1002 19.8054C19.2022 19.8478 19.3115 19.8697 19.4219 19.8697C19.5323 19.8697 19.6416 19.8478 19.7436 19.8054C19.8455 19.7629 19.938 19.7007 20.0158 19.6223C20.0942 19.5445 20.1564 19.452 20.1988 19.3501C20.2413 19.2482 20.2632 19.1389 20.2632 19.0284C20.2632 18.918 20.2413 18.8087 20.1988 18.7068C20.1564 18.6049 20.0942 18.5123 20.0158 18.4346L16.4192 14.8464Z",
		fill: "#37598A"
	})]
});
export default SvgClose;
